import { render, staticRenderFns } from "./OrderContainer.vue?vue&type=template&id=10ed415c&scoped=true"
import script from "./OrderContainer.vue?vue&type=script&lang=ts"
export * from "./OrderContainer.vue?vue&type=script&lang=ts"
import style0 from "./OrderContainer.vue?vue&type=style&index=0&id=10ed415c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed415c",
  null
  
)

export default component.exports